// EventTrackerContext.tsx
import React, { createContext, useContext } from 'react';
import { useEventTrackerImpl } from './useEventTracker';
import { EventTracker, UseEventTrackerOptions } from '../model/UseEventTrackerTypes';

const EventTrackerContext = createContext<EventTracker | null>(null);

interface ProviderProps {
    options: UseEventTrackerOptions;
    children: React.ReactNode;
}

export function EventTrackerProvider({ options, children }: ProviderProps) {
    const tracker = useEventTrackerImpl(options);
    return (
        <EventTrackerContext.Provider value={tracker} >
            {children}
        </EventTrackerContext.Provider>
    );
}

// 3. Hook pubblico che prende il singleton dal context
export function useEventTracker(): EventTracker {
    const ctx = useContext(EventTrackerContext);
    if (!ctx) {
        throw new Error('useEventTracker va usato dentro un <EventTrackerProvider>');
    }
    return ctx;
}
